import { LitElement, html, svg } from 'lit';

export class IconSend24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Papirfly</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1.4 3.743a1.5 1.5 0 0 1 1.973-2.077l19.014 9.659a.75.75 0 0 1 0 1.337L3.373 22.334A1.5 1.5 0 0 1 1.4 20.257l5.058-8.264L1.4 3.743ZM22.797 11.993H6.453"></path></svg>`; }
}
if (!customElements.get('f-icon-send24', IconSend24)) {
  customElements.define('f-icon-send24', IconSend24);
}